<cms-resource-explorer
  class="h-100"
  [applicationCode]="applicationCode()"
  [usePathsOnly]="true"
  [mini]="mini()"
  [allowEdit]="allowEdit()"
  [baseQuery]="baseQuery()"
  explorerTitle="Evolutics Help"
  [menu]="configMainMenu()" />
